module.exports = __webpack_public_path__ + "static/media/clockBlack.1f879721.svg";